import { IAlarmManagement } from '@interfaces/alarms/alarm';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { TUserRoles } from '@enums/common';
import { EAlarmManagementFields } from './enums';

import { hoursOptions, minutesOptions, nonNullishMinutesOptions } from '@constants/timeOptions';

import { IFieldsAlarmManagementForm } from './AlarmManagementForm';

export const prepareDefaultValues = ({
	editableAlarm,
	rolesOptions,
	usersOptions,
}: {
	editableAlarm?: IAlarmManagement;
	rolesOptions: TSelectOptionType<TUserRoles>[];
	usersOptions: TSelectOptionType<string>[];
}): IFieldsAlarmManagementForm => {
	const roles = editableAlarm && rolesOptions.length
		? rolesOptions.filter((option) => {
			const selectedRoles = editableAlarm.roles?.map(role => role.name);

			return option?.value && selectedRoles?.includes(option?.value);
		}) : null;

	const users = editableAlarm && usersOptions.length
		? usersOptions?.filter((option) => {
			const selectedUsers = editableAlarm.users?.map(user => user.id);

			return option?.value && selectedUsers?.includes(option?.value);
		}) : null;

	const networkElementFields = editableAlarm?.customSettings?.noVesEventAlarmCreateSettings
		?.filter(Boolean)
		.map((option, index) => {
			const networkElement = {
				value: option.networkElementId,
				label: option.networkElementName,
				name: option.networkElementName,
			};

			const minutes = {
				value: option.noEventMinutes,
				label: option.noEventMinutes,
				name: option.noEventMinutes,
			};

			return {
				minutes,
				networkElement,
				ruleId: option.id,
				id: index.toString(),
			};
		}) || [];

	const autoClearMinutes = nonNullishMinutesOptions
		.find((option) => option?.value === editableAlarm?.autoClearMinutes) || null;

	return {
		[EAlarmManagementFields.isActive]: !!editableAlarm?.isEnabled,
		[EAlarmManagementFields.frequency]: editableAlarm?.frequency?.name ?? null,
		[EAlarmManagementFields.numberOfRepetitions]: editableAlarm?.numberOfRepetitions ?? null,
		[EAlarmManagementFields.repetitionHours]: hoursOptions.find((option) =>
			option?.value === editableAlarm?.repetitionHours) || null,
		[EAlarmManagementFields.repetitionMinutes]: minutesOptions.find((option) =>
			option?.value === editableAlarm?.repetitionMinutes) || null,
		[EAlarmManagementFields.renotify]: editableAlarm?.renotify?.name ?? null,
		[EAlarmManagementFields.renotifyHours]: hoursOptions.find((option) =>
			option?.value === editableAlarm?.renotifyHours) || null,
		[EAlarmManagementFields.renotifyMinutes]: minutesOptions.find((option) =>
			option?.value === editableAlarm?.renotifyMinutes) || null,
		[EAlarmManagementFields.isEmail]: !!editableAlarm?.isEmail,
		[EAlarmManagementFields.isNotification]: !!editableAlarm?.isNotification,
		[EAlarmManagementFields.roles]: roles,
		[EAlarmManagementFields.users]: users,
		[EAlarmManagementFields.networkElementFields]: networkElementFields,
		[EAlarmManagementFields.autoClearMinutes]: autoClearMinutes,
	};
};
